<template>
  <div>
    <section>
      <ContractorsDataTable
      ></ContractorsDataTable>
    </section>

  </div>
</template>

<script>
  import ContractorsDataTable from '../../util/Contractors/ContractorsDataTable';

    export default {
      name: "ContractorsPage",
      components: {ContractorsDataTable},
      data() {
        return {

        }
      },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Manage/ContractorsPage.vue